import * as React from 'react';
import classnames from 'classnames';
import { Select } from '@grandvisionhq/forms';
import { H3 } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';

const SubscriptionDeliveryIntervalSelect = /*#__PURE__*/ React.memo(({ className , hasError , headingVariant ='heading-smallest' , singleOptionLabel , deliveryIntervalOptions , selectedInterval , onIntervalSelection  })=>{
    const { getLabel  } = useIntl();
    const title = getLabel('products.subscriptions.deliveryInterval.title');
    const sortedOptions = React.useMemo(()=>Object.fromEntries(Object.entries(deliveryIntervalOptions).sort((a, b)=>a[1] - b[1]
        ))
    , [
        deliveryIntervalOptions
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('subscription-delivery-interval-select', className)
    }, /*#__PURE__*/ React.createElement(H3, {
        className: "subscription-delivery-interval-select__title",
        variant: headingVariant
    }, title), singleOptionLabel ? /*#__PURE__*/ React.createElement(React.Fragment, null, singleOptionLabel) : /*#__PURE__*/ React.createElement(Select, {
        className: "subscription-delivery-interval-select__select",
        placeholder: getLabel('products.subscriptions.deliveryInterval.placeholder'),
        id: "delivery_interval_select",
        name: "delivery_interval_select",
        options: sortedOptions,
        initialState: selectedInterval,
        onChange: onIntervalSelection,
        "aria-invalid": hasError,
        "aria-label": title,
        required: true,
        "data-t": "delivery-interval-select"
    }));
});

export { SubscriptionDeliveryIntervalSelect };
//# sourceMappingURL=SubscriptionDeliveryIntervalSelect.js.map
